module.exports = __webpack_public_path__ + "img/addresses-light.b5e01614.svg";